<template>
  <div class="recharge-input-item-wrap">
    <template v-for="(conf, index) in config">
      <input type="text" class="hiddenInput" :key="`_${index}`" />
      <!--单选-->
      <div
        class="recharge-input-item"
        v-if="['radio'].includes(conf.compType)"
        :class="{ half: conf.halfColumn }"
        :key="conf.key"
      >
        <div class="recharge-label">
          <span>{{ conf.label }}</span>
          <span>{{ conf.description }}</span>
          <span class="btn" v-if="conf.labelBtnConf" @click="conf.labelBtnConf.fn && conf.labelBtnConf.fn()">
            {{ conf.labelBtnConf.text }}
          </span>
        </div>
        <div class="recharge-radio">
          <span
            v-for="(item, index) in conf.list"
            :key="index"
            :class="{ active: renderData[conf.key] === item.value }"
            @click="renderData[conf.key] = item.value"
            >{{ item.name }}</span
          >
        </div>
      </div>

      <div
        class="recharge-input-item"
        v-if="['select'].includes(conf.compType)"
        :class="{ half: conf.halfColumn }"
        :key="conf.key"
      >
        <div class="recharge-label memo-spacing">
          <span>{{ conf.label }}</span>
          <span>{{ conf.description }}</span>
          <span class="btn" v-if="conf.labelBtnConf" @click="conf.labelBtnConf.fn && conf.labelBtnConf.fn()">
            {{ conf.labelBtnConf.text }}
          </span>
        </div>
        <!-- <q-select
          v-model="renderData[conf.key]"
          @input="selectChange"
          class="quasar-qselect glay-bg"
          :options="conf.options"
        ></q-select> -->
        <v-select
          v-model="renderData[conf.key]"
          class="quasar-qselect grey-bg"
          @change="selectChange"
          flat
          single-line
          dense
          outlined
          item-text="label"
          item-value="value"
          :items="conf.options"
          :menu-props="{ offsetY: true }"
        ></v-select>
      </div>

      <div
        class="recharge-input-item"
        v-if="['numberInput'].includes(conf.compType)"
        :class="{ half: conf.halfColumn }"
        :key="conf.key"
      >
        <div class="recharge-label">
          <span>{{ conf.label }}</span>
          <span>{{ conf.description }}</span>
          <span class="btn" v-if="conf.labelBtnConf" @click="conf.labelBtnConf.fn && conf.labelBtnConf.fn()">
            {{ conf.labelBtnConf.text }}
          </span>
        </div>
        <div class="recharge-input-tail">
          <input :disabled="conf.disabled" type="number" v-model="renderData[conf.key]" />
          <span @click="conf.tailFn && conf.tailFn()">{{ conf.tail }}</span>
        </div>
      </div>

      <div
        class="recharge-input-item"
        v-if="['limitNumberInput'].includes(conf.compType)"
        :class="{ half: conf.halfColumn }"
        :key="conf.key"
      >
        <div class="recharge-label">
          <span>{{ conf.label }}</span>
          <span>{{ conf.description }}</span>
          <span class="btn" v-if="conf.labelBtnConf" @click="conf.labelBtnConf.fn && conf.labelBtnConf.fn()">
            {{ conf.labelBtnConf.text }}
          </span>
        </div>
        <div class="recharge-input-tail">
          <InputComponent
            class="input-component"
            :ref="`custom${conf.key}`"
            :maxlength="16"
            :maxdecimal="conf.maxDecimal"
            v-model="renderData[conf.key]"
          ></InputComponent>
          <span @click="conf.tailFn && conf.tailFn()">{{ conf.tail }}</span>
        </div>
      </div>

      <div
        class="recharge-input-item"
        v-if="['textInput'].includes(conf.compType)"
        :class="{ half: conf.halfColumn, date: conf.dateColumn }"
        :key="conf.key"
      >
        <div class="recharge-label memo-spacing ">
          <span>{{ conf.label }}</span>
          <span>{{ conf.description }}</span>
          <span class="btn" v-if="conf.labelBtnConf" @click="conf.labelBtnConf.fn && conf.labelBtnConf.fn()">
            {{ conf.labelBtnConf.text }}
          </span>
        </div>
        <div class="recharge-input-tail">
          <input type="text" v-model="renderData[conf.key]" />
          <span @click="conf.tailFn && conf.tailFn()" :class="{ high: conf.tailFn }">{{ conf.tail }}</span>
        </div>
      </div>

      <div
        class="recharge-input-item"
        v-if="['datetime'].includes(conf.compType)"
        :class="{ half: conf.halfColumn, date: conf.dateColumn }"
        :key="conf.key"
      >
        <div class="recharge-label ">
          <span>{{ conf.label }}</span>
          <span>{{ conf.description }}</span>
          <span class="btn" v-if="conf.labelBtnConf" @click="conf.labelBtnConf.fn && conf.labelBtnConf.fn()">
            {{ conf.labelBtnConf.text }}
          </span>
        </div>
        <div class="recharge-input-tail">
          <input type="date" v-model="renderData[conf.key]" />
          <span @click="conf.tailFn && conf.tailFn()" :class="{ high: conf.tailFn }">{{ conf.tail }}</span>
        </div>
      </div>

      <div
        class="recharge-input-item"
        v-if="['password'].includes(conf.compType)"
        :class="{ half: conf.halfColumn }"
        :key="conf.key"
      >
        <div class="recharge-label">
          <span>{{ conf.label }}</span>
          <span>{{ conf.description }}</span>
          <span class="btn" v-if="conf.labelBtnConf" @click="conf.labelBtnConf.fn && conf.labelBtnConf.fn()">
            {{ conf.labelBtnConf.text }}
          </span>
        </div>
        <div class="recharge-input-tail">
          <input type="password" v-model="renderData[conf.key]" />
          <span @click="conf.tailFn && conf.tailFn()" :class="{ high: conf.tailFn }">{{ conf.tail }}</span>
        </div>
      </div>

      <div
        class="recharge-input-item"
        v-if="['textCopy'].includes(conf.compType)"
        :class="{ half: conf.halfColumn }"
        :key="conf.key"
      >
        <div class="recharge-label ">
          <span>{{ conf.label }}</span>
          <span>{{ conf.description }}</span>
          <span class="btn" v-if="conf.labelBtnConf" @click="conf.labelBtnConf.fn && conf.labelBtnConf.fn()">
            {{ conf.labelBtnConf.text }}
          </span>
        </div>
        <GQrCode :conf="conf" :renderData="renderData"></GQrCode>
      </div>
      <input type="text" class="hiddenInput" :key="`__${index}`" />
    </template>
  </div>
</template>
<script>
import GQrCode from './GQrCode';
import InputComponent from './InputComponent';

export default {
  name: 'GForm',
  components: { GQrCode, InputComponent },
  props: ['config', 'renderData'],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    selectChange(val) {
      this.$emit('selectChange', val);
    }
  }
};
</script>
<style lang="stylus" scoped>
.hiddenInput {
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
}
.v-select.quasar-qselect.grey-bg::v-deep {
  background-color: rgba(230, 234, 240, 0.5);
  border: 1px solid #e6eaf0;
  .v-input__control {
    .v-input__slot {
      margin-bottom: 0;
      fieldset {
        border: none;
      }
    }
    .v-text-field__details {
      display: none;
    }
  }
}
.recharge-input-item-wrap {
  display: flex;
  flex-wrap: wrap;
}
.recharge-input-item {
  flex: 0 0 100%;
  padding: 0 10px;
}
.recharge-input-item.half {
  flex: 0 0 50%;
}
.recharge-input-item.date {
  flex: 0 0 25%;
}
.recharge-label {
  font-size: 14px;
  line-height: 48px;
  color: rgba(138, 144, 154, 1);
  display: flex;
}
.recharge-label > span:not(:first-child) {
  flex: 1 1 0px;
  text-align: right;
  font-size: 14px;
}
.recharge-label > span.btn {
  flex: 0 0 auto;
  padding-left: 10px;
  color: #4d67b2;
  cursor: pointer;
  user-select: none;
}
.recharge-input-tail {
  display: flex;
  height: 44px;
  background: rgba(230, 234, 240, 0.5);
  border: 1px solid rgba(230, 234, 240, 1);
  border-radius: 2px;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
}
.recharge-input-tail input {
  position: relative;
  flex: 1 1 0px;
  background-color: transparent;
  padding: 0 10px;
  color: #666;
  font-size: 14px;
  padding-left: 0px;
  padding-right: 0px;
}
.recharge-input-tail span {
  /* position: absolute;
    top: 0;
    right: 10px; */
  margin-left: auto;
  padding-left: 10px;
  line-height: 44px;
}
.recharge-input-tail span.high {
  z-index: 2;
  cursor: pointer;
  color: #4d67b2;
  user-select: none;
}
.recharge-input-tail span.high:active {
  opacity: 0.8;
}
.recharge-radio {
  display: flex;
}
.recharge-radio > span {
  height: 46px;
  line-height: 46px;
  padding: 0 50px;
  border: 1px solid transparent;
  background: rgba(230, 234, 240, 1);
  border-radius: 2px;
  margin-right: 30px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  cursor: pointer;
}
.recharge-radio > span::before {
  position: absolute;
  content: '';
  bottom: 0;
  right: 0;
  width: 26px;
  height: 24px;
  border-bottom: 12px solid rgba(77, 103, 178, 1);
  border-right: 13px solid rgba(77, 103, 178, 1);
  border-left: 13px solid transparent;
  border-top: 12px solid transparent;
  opacity: 0;
  transition: all 0.3s;
}
.recharge-radio > span::after {
  position: absolute;
  content: '';
  bottom: 0;
  right: 0;
  width: 6px;
  height: 10px;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  transform: translate(-5px, -5px) rotate(45deg);
  opacity: 0;
  transition: all 0.3s;
}
.recharge-radio > span.active {
  border: 1px solid rgba(77, 103, 178, 1);
  background: rgba(255, 255, 255, 1);
}
.recharge-radio > span.active::before,
.recharge-radio > span.active::after {
  opacity: 1;
}
.recharge-foot-tip {
  display: flex;
  padding-top: 10px;
  margin: 0 10px;
}
.recharge-foot-tip p {
  flex: 1 1 0px;
  font-size: 14px;
  color: rgba(138, 144, 154, 1);
  line-height: 24px;
}
.recharge-foot-tip div {
  display: flex;
  align-items: flex-end;
}
.recharge-foot-tip > div > span {
  height: 46px;
  line-height: 46px;
  color: #fff;
  font-size: 16px;
  padding: 0 60px;
  background: rgba(77, 103, 178, 1);
  opacity: 1;
  border-radius: 2px;
}
.recharge-form {
  padding: 20px 20px;
}
.recharge-tip {
  font-size: 14px;
  color: rgba(77, 103, 178, 1);
  line-height: 20px;
  background: rgba(77, 103, 178, 0.2);
  border: 1px solid rgba(77, 103, 178, 1);
  border-radius: 2px;
  padding: 10px 35px;
  position: relative;
  margin: 0 10px;
}
.recharge-tip::before {
  position: absolute;
  content: '!';
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  background-color: #4d67b2;
  color: #fff;
  border-radius: 8px;
  top: 12px;
  left: 10px;
}
.recharge-tip p {
  margin: 0;
}
.input-component {
  width: 100%;
}
.input-component::v-deep input {
  background-color: transparent;
  border: none;
  color: #000000;
  padding-left: 0px;
  padding-right: 0px;
  width: inherit;
}

@media screen and (max-width: 800px) {
  .memo-spacing{
    line-height: 18px;
    margin: 10px 0px;
    font-size: 10px;
  }
}
@media screen and (max-width: 767px) {
  .memo-spacing{
    line-height: 18px;
    margin: 10px 0px;
  }
}
</style>
